import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-31885f24"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "invite-box"
};
const _hoisted_2 = {
  class: "fixed-header"
};
const _hoisted_3 = {
  class: "header-right"
};
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 规则 ");
const _hoisted_5 = {
  class: "smile-icon"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "points-label"
}, "我的积分", -1));
const _hoisted_7 = {
  class: "points-value"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "arrow"
}, null, -1));
const _hoisted_9 = {
  class: "submit-content"
};
const _hoisted_10 = {
  class: "filter_bg"
};
const _hoisted_11 = {
  class: "filter-tabs"
};
const _hoisted_12 = {
  class: "tabs-left"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "积分换购", -1));
const _hoisted_14 = {
  class: "prize-list"
};
const _hoisted_15 = {
  key: 0,
  class: "empty-list"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
  class: "card-header"
};
const _hoisted_18 = {
  class: "countdown"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "开奖时间", -1));
const _hoisted_20 = {
  class: "time"
};
const _hoisted_21 = {
  class: "participants"
};
const _hoisted_22 = {
  class: "avatar-group"
};
const _hoisted_23 = {
  key: 0,
  class: "count"
};
const _hoisted_24 = {
  class: "card-content"
};
const _hoisted_25 = {
  class: "product-info"
};
const _hoisted_26 = {
  class: "product-name"
};
const _hoisted_27 = {
  class: "project-name"
};
const _hoisted_28 = {
  class: "price-row"
};
const _hoisted_29 = {
  class: "price-row-left"
};
const _hoisted_30 = {
  class: "price-group"
};
const _hoisted_31 = {
  class: "current-price"
};
const _hoisted_32 = {
  class: "original-price"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "divider"
}, "|", -1));
const _hoisted_34 = {
  class: "limit-text"
};
const _hoisted_35 = {
  class: "join-btn"
};
const _hoisted_36 = {
  key: 1,
  class: "loading-more"
};
const _hoisted_37 = /*#__PURE__*/_createTextVNode("加载中...");
const _hoisted_38 = {
  key: 2,
  class: "no-more"
};
import { env } from "md-base-tools/env";
import domain from "@/service/domain";
import router from '@/router';
import { onMounted, onUnmounted, ref, nextTick } from "vue";
import { mdToast } from "../../utils/tools";
import CompLottieAnimation from '@@/lottieAnimation.vue';
import api from '@api';
import { getToken, goToLogin } from '@/utils/user';

// const isFix = ref(0);

export default {
  setup(__props) {
    const activeTab = ref('all'); // 默认选中 0元免单
    const userIntegral = ref('--'); // 用户积分，默认 --

    // Tab 元素引用
    const tabAll = ref(null);
    const tabFree = ref(null);
    const tabDiscount = ref(null);

    // 指示器位置和宽度
    const indicatorLeft = ref('15px');
    const indicatorWidth = ref('30px');

    // 列表数据
    const prizeList = ref([]);
    const loading = ref(false);
    const finished = ref(false);
    const page = ref(1);
    const pageSize = ref(10);

    // 滚动容器引用
    const prizeListWrapper = ref(null);

    // 获取 tab 参数
    const getTabParam = () => {
      const tabMap = {
        'all': 0,
        // 全部
        'free': 1,
        // 0元免单
        'discount': 2 // 限时折扣
      };
      return tabMap[activeTab.value];
    };

    // 获取活动列表
    const getActivityList = async (isLoadMore = false) => {
      if (loading.value || finished.value) return;
      loading.value = true;
      try {
        const res = await api.getSubmitList({
          tab: getTabParam(),
          page: page.value,
          page_size: pageSize.value
        });
        if (res.status === 0 && res.data) {
          const list = res.data.list || [];
          if (isLoadMore) {
            // 加载更多：追加数据
            prizeList.value = [...prizeList.value, ...list];
          } else {
            // 首次加载或切换 tab：替换数据
            prizeList.value = list;
          }

          // 判断是否还有下一页
          finished.value = !res.data.is_next;
          if (res.data.is_next) {
            page.value++;
          }
        } else {
          mdToast(res.message || '获取列表失败');
          finished.value = true;
        }
      } catch (error) {
        console.error('获取活动列表失败:', error);
        mdToast('网络错误，请稍后重试');
        finished.value = true;
      } finally {
        loading.value = false;
      }
    };

    // 监听滚动加载更多
    const handleScroll = () => {
      if (loading.value || finished.value) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = window.innerHeight;

      // 距离底部 100px 时触发加载
      if (scrollTop + clientHeight >= scrollHeight - 100) {
        getActivityList(true);
      }
    };

    // 更新指示器位置和宽度
    const updateIndicator = () => {
      nextTick(() => {
        const tabMap = {
          'all': tabAll.value,
          'free': tabFree.value,
          'discount': tabDiscount.value
        };
        const activeTabEl = tabMap[activeTab.value];
        if (activeTabEl) {
          const width = activeTabEl.offsetWidth;
          const left = activeTabEl.offsetLeft;
          indicatorLeft.value = `${left}px`;
          indicatorWidth.value = `${width}px`;
        }
      });
    };

    // 获取用户积分
    const fetchUserIntegral = async () => {
      // 检查用户是否登录
      const token = getToken();
      if (!token) {
        userIntegral.value = '--';
        return;
      }
      try {
        const res = await api.getUserIntegral({
          cp_user_id: 1
        });
        if (res.status === 0 && res.data) {
          userIntegral.value = res.data.balance || 0;
        } else {
          userIntegral.value = '--';
        }
      } catch (error) {
        console.error('获取用户积分失败:', error);
        userIntegral.value = '--';
      }
    };

    // 点击积分区域
    const handlePointsClick = () => {
      const token = getToken();

      // 未登录，跳转登录
      if (!token) {
        goToLogin();
        return;
      }

      // 已登录，跳转积分页面
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: 'md://user_score',
        callBack: () => {},
        webFun: () => {}
      });
    };
    onMounted(() => {
      document.title = '积分抽奖';

      // 延迟更新指示器，确保 DOM 已渲染
      setTimeout(() => {
        updateIndicator();
      }, 100);

      // 获取用户积分
      fetchUserIntegral();

      // 获取初始列表
      getActivityList();

      // 监听页面滚动事件
      window.addEventListener('scroll', handleScroll);
    });

    // 组件卸载时移除监听
    onUnmounted(() => {
      window.removeEventListener('scroll', handleScroll);
    });

    //规则说明
    function handleTaskRule() {
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: `${domain.wap}/prize/submit_rule`,
        webFun: () => {
          router.push({
            path: `/prize/submit_rule`
          });
        }
      });
    }

    // 中奖记录
    function handleRecordRule() {
      const token = getToken();

      // 未登录，跳转登录
      if (!token) {
        goToLogin();
        return;
      }

      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: `md://prizeRecordList`,
        webFun: () => {}
      });
    }

    // 立即参与
    function handleItemClick(item) {
      // 跳转到活动详情页
      if (item.jump_url) {
        // eslint-disable-next-line no-undef
        graft.app({
          functionName: "openController",
          functionParams: item.jump_url,
          webFun: () => {}
        });
      }
    }

    // 切换 Tab
    function switchTab(tab) {
      if (activeTab.value === tab) return;
      activeTab.value = tab;
      updateIndicator();

      // 重置数据并重新请求
      page.value = 1;
      finished.value = false;
      prizeList.value = [];

      // 滚动页面到顶部
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });

      // 重新获取数据
      getActivityList();
    }

    // 积分换购
    function handlePointsExchange() {
      let url = 'md://mini_program?id=wx6a3c68659310e879&name=gh_7210ac3f1f08&path=pages/index/index?nextUrl=pages/score/exchange/exchange';
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: url,
        webFun: async () => {}
      });
    }

    //离开页面
    // function handleGoBack() {
    //     GoBack()
    // }

    //是否吸顶
    // function handleStickyAction(is_fix) {
    //     isFix.value = is_fix ? 1 : 0
    // }

    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_van_empty = _resolveComponent("van-empty");
      const _component_van_loading = _resolveComponent("van-loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: "rule-info",
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => handleTaskRule(), ["stop"]))
      }, [_createVNode(_component_van_image, {
        class: "icon",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/score/task_rule_icon.png', 32)
      }, null, 8, ["src"]), _hoisted_4]), _unref(env).isModianIos() || _unref(env).isModianAndroid() ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "history-info",
        onClick: _cache[1] || (_cache[1] = _withModifiers($event => handleRecordRule(), ["stop"]))
      }, " 中奖记录 ")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_5, [_createVNode(CompLottieAnimation, {
        class: "smile-icon",
        jsonUrl: "https://p6.moimg.net/mdwxapp/cp_submit_list.json",
        loop: true
      })]), _createElementVNode("div", {
        class: "points-info",
        onClick: handlePointsClick
      }, [_hoisted_6, _createElementVNode("span", _hoisted_7, _toDisplayString(userIntegral.value), 1), _hoisted_8])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", {
        ref_key: "tabAll",
        ref: tabAll,
        class: _normalizeClass(["tab-item", {
          active: activeTab.value === 'all'
        }]),
        onClick: _cache[2] || (_cache[2] = $event => switchTab('all'))
      }, "全部", 2), _createElementVNode("div", {
        ref_key: "tabFree",
        ref: tabFree,
        class: _normalizeClass(["tab-item", {
          active: activeTab.value === 'free'
        }]),
        onClick: _cache[3] || (_cache[3] = $event => switchTab('free'))
      }, "0元免单", 2), _createElementVNode("div", {
        ref_key: "tabDiscount",
        ref: tabDiscount,
        class: _normalizeClass(["tab-item", {
          active: activeTab.value === 'discount'
        }]),
        onClick: _cache[4] || (_cache[4] = $event => switchTab('discount'))
      }, "限时折扣", 2)]), _createElementVNode("div", {
        class: "points-exchange",
        onClick: handlePointsExchange
      }, [_hoisted_13, _createVNode(_component_van_icon, {
        name: "arrow",
        color: "#004d3f",
        size: "10"
      })]), _createElementVNode("div", {
        class: "tab-indicator",
        style: _normalizeStyle({
          left: indicatorLeft.value,
          width: indicatorWidth.value
        })
      }, null, 4)])]), _createElementVNode("div", {
        ref_key: "prizeListWrapper",
        ref: prizeListWrapper,
        class: "prize-list-wrapper"
      }, [_createElementVNode("div", _hoisted_14, [!loading.value && prizeList.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createVNode(_component_van_empty, {
        description: "暂无活动"
      })])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prizeList.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "prize-card",
          key: item.activity_id + '_' + index,
          onClick: $event => handleItemClick(item)
        }, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("span", _hoisted_20, _toDisplayString(item.draw_time), 1)]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList((item.join_user_list || []).slice(0, 5), (user, idx) => {
          return _openBlock(), _createBlock(_component_van_image, {
            class: "avatar",
            round: "",
            key: user.user_id + '_' + idx,
            src: _ctx.$imgUrlFilter(user.icon || 'https://p6.moimg.net/mdwxapp/default_avatar.png', 32)
          }, null, 8, ["src"]);
        }), 128))]), item.join_number > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(item.join_number) + "人参与", 1)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_24, [_createVNode(_component_van_image, {
          class: "product-image",
          src: _ctx.$imgUrlFilter(item.logo, 300)
        }, null, 8, ["src"]), _createElementVNode("div", _hoisted_25, [_createElementVNode("h3", _hoisted_26, _toDisplayString(item.activity_title), 1), _createElementVNode("p", _hoisted_27, _toDisplayString(item.pro_name), 1), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createElementVNode("span", _hoisted_31, "￥" + _toDisplayString(item.mark_price), 1), _createElementVNode("span", _hoisted_32, "￥" + _toDisplayString(item.price), 1)]), _hoisted_33, _createElementVNode("span", _hoisted_34, "限" + _toDisplayString(item.stock) + "份", 1)]), _createElementVNode("button", _hoisted_35, _toDisplayString(item.join_status ? '提高中奖率' : '立即参与'), 1)])])])], 8, _hoisted_16);
      }), 128)), loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_createVNode(_component_van_loading, {
        type: "spinner",
        size: "24"
      }, {
        default: _withCtx(() => [_hoisted_37]),
        _: 1
      })])) : _createCommentVNode("", true), !loading.value && finished.value && prizeList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_38, " 没有更多了 ")) : _createCommentVNode("", true)])], 512)])]);
    };
  }
};